<template>
  <div class="authorised" :class="{'authorised--hidden': !active}" @click="toggleAuthorised(false)">
    <div class="authorised__container" @click.stop>
      <div class="authorised__stamp_up"></div>
      <div class="authorised__stamp_down"></div>
      <div class="authorised__text">
        <h1>{{ $t('legalH1') }}</h1>
        <br/>
        {{ $t('legalP1') }}
        <br/><br/>
        {{ $t('legalP2') }}
        <br/><br/><br/>
        <h2>{{ $t('legalH2') }}</h2>
        <br/>
        {{ $t('legalP3') }}
        <br/><br/>
        {{ $t('legalP4') }}
        <br/><br/>
        <div class="authorised__item"><span class="authorised__check icon-checkmark"></span>{{ $t('legalL1') }}</div>
        <div class="authorised__item"><span class="authorised__check icon-checkmark"></span>{{ $t('legalL2') }}</div>
        <div class="authorised__item"><span class="authorised__check icon-checkmark"></span>{{ $t('legalL3') }}</div>
        <div class="authorised__item"><span class="authorised__check icon-checkmark"></span>{{ $t('legalL4') }}</div>
        <br/>
        {{ $t('legalP5') }}
        <br/><br/>
        {{ $t('legalP6') }}
      </div>
      <div class="authorised__close icon-close" @click="toggleAuthorised(false)"></div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'Auth',
    computed: {
      active () {
        return this.$store.state.showLegalModal
      }
    },
    methods: {
      toggleAuthorised (bool) {
        this.$store.commit('showLegalModal', bool)
      }
    }
  }
</script>

<style scoped>
  .authorised {
    position: fixed;
    z-index: 20;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    background: rgba(23, 33, 47, .6);
  }
  .authorised--hidden {
    display: none;
  }
  .authorised__container {
    position: relative;
    padding: 2rem;
    background: #FFF;
    text-align: left;
    width: 90%;
    max-width: 700px;
    font-size: 14px;
    line-height: 20px;
    box-sizing: border-box;
    height: 90%;
    max-height: 800px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
  .authorised__item {
    padding-bottom: 10px;
  }
  .authorised__stamp_up {
    position: absolute;
    top: 0;
    left: 0;
    background: url('/static/images/stamp1.png');
    width: 191px;
    height: 191px;
  }
  .authorised__stamp_down {
    position: absolute;
    bottom: 20px;
    right: 20px;
    background: url('/static/images/stamp2.png');
    width: 120px;
    height: 120px;
  }
  .authorised__container h1, .authorised__container h2 {
    text-align: center;
    font-weight: normal;
    margin: 0;
  }
  .authorised__container h1 {
    font-size: 16px;
    letter-spacing: 4px;
  }
  .authorised__container h2 {
    font-size: 12px;
    letter-spacing: 2px;
  }
  .authorised__check {
    padding-right: 20px;
  }
  .authorised__text {
    overflow: auto;
    -webkit-overflow-scrolling: touch;
    padding: 1rem;
    position: relative;
    z-index: 5;
  }
  .authorised__close {
    position: absolute;
    top: 0;
    right: 0;
    background: #FFF;
    width: 30px;
    font-size: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 30px;
    cursor: pointer;
  }
</style>

<style src="@/assets/dw-icons/styles.css" lang="css"></style>



// WEBPACK FOOTER //
// Authorised.vue?e51756b4